import GoogleMap_WithConsentWrapperComponent from '../components/GoogleMap/viewer/skinComps/WithConsentWrapper/WithConsentWrapper.skin';
import GoogleMap_WithConsentWrapperController from '../components/GoogleMap/viewer/GoogleMap.controller';


const GoogleMap_WithConsentWrapper = {
  component: GoogleMap_WithConsentWrapperComponent,
  controller: GoogleMap_WithConsentWrapperController
};


export const components = {
  ['GoogleMap_WithConsentWrapper']: GoogleMap_WithConsentWrapper
};

